import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";

const ChargingPoint = ({ props }) => {

  const classes = useStyles();

  const arr = props?.map((props, i) => (
    <Box
      className={classes.Chargingpoint}
      key={i}
      sx={{
        justifyContent: "space-between",
        width: "28%",
        background: "#F3F3F3 0% 0% no-repeat padding-box",
        borderRadius: "4px",
        padding: "10px",
        marginTop: "10px",
        marginRight: "25px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            color: "#707070",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {props.name}
          <br></br>Id : {props.cpId}
        </Text>
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            marginLeft: "30px",
            color: "#707070",
            fontSize: "14px",
          }}
        >
          {props.status === 1 ? "Available" : "Not Available "}
        </Text>
      </Box>
    </Box>
  ));
  return <>{arr}</>;
};

const useStyles = makeStyles((theme) => ({
  Chargingpoint: {
    ["@media (max-width:768px)"]: {
      width: "87%",
    },
  },
}));

export default ChargingPoint;
